import {
  Component,
  Input,
  ViewChild,
} from '@angular/core';

import { CollapseComponent } from '../collapse/collapse.component';


@Component({
  moduleId: module.id,
  selector: 'collapse-info-widget',
  templateUrl: 'collapse-info-widget.component.html',
  styleUrls: ['collapse-info-widget.component.scss'],
})
export class CollapseInfoWidgetComponent {
  @Input() headerTitle: string = '';
  @Input() collapseText: string = 'Collapse';
  @Input() explainText: string = 'Explain';
  @Input() paragraph1: string = '';
  @Input() paragraph2: string = '';
  @Input() bgcolor: string = 'white';

  // icon class from scss/icon.scss, 72x72px
  @Input() imgIconClass: string = '';

  @ViewChild(CollapseComponent, {static: false})
  collapseComponent: CollapseComponent | void;

  get toggleText() {
    return this.isCollapse ? this.explainText : this.collapseText;
  }

  get isCollapse() {
    return this.collapseComponent && this.collapseComponent.collapse;
  }
}
